import React from 'react';
import { isMobile } from 'react-device-detect';
import { formatStatsValue } from 'common-helpers/utils';
import Row, { RowBetween } from 'components/Row';
import { AutoColumn } from 'components/Column';
import { TYPE } from 'theme';
import { Card } from '../styled';
import { UserGecStatsV2 } from 'gql-ops/graph/__generated__/request';
import { CardContent } from './seasonStyles';

interface Season3Props {
    gecStatsV2: UserGecStatsV2;
}

const Season3: React.FC<Season3Props> = ({ gecStatsV2 }) => {
    return (
        <>
            <Row>
                <TYPE.main fontSize={16} fontWeight={700} mobileFz={14}>
                    Season 3 (Ended)
                </TYPE.main>
            </Row>
            <RowBetween gap="20px" wrap="wrap">
                <Card
                    background="#121212"
                    bgIcon="rocket"
                    height={isMobile ? 'auto' : '169px'}
                    width={isMobile ? '100%' : '600px'}
                    padding="20px"
                >
                    <CardContent>
                        <AutoColumn gap="6px">
                            <TYPE.desc fontSize={14} fontWeight={500}>
                                GOAT points
                            </TYPE.desc>
                            <TYPE.desc fontSize={10} color="#999">
                                GOAT Points are used to receive airdrop
                            </TYPE.desc>
                        </AutoColumn>
                        <RowBetween gap="20px" align="center" alignItems="center" marginTop="20px" wrap="wrap">
                            <AutoColumn style={{ height: '50px' }}>
                                <TYPE.main fontSize={10}>Social points</TYPE.main>
                                <Row gap="6px" align="center" alignItems="center" marginTop="10px">
                                    <TYPE.main fontSize={24} fontWeight={500}>
                                        +
                                        {formatStatsValue(
                                            BigInt(gecStatsV2.season3Stats.socialPoint || '0').toString(),
                                        )}
                                    </TYPE.main>
                                    <TYPE.desc fontSize={14}>Points</TYPE.desc>
                                </Row>
                            </AutoColumn>
                            <AutoColumn style={{ height: '50px' }}>
                                <Row gap="2px">
                                    <TYPE.main fontSize={10}>On Chain Points</TYPE.main>
                                </Row>
                                <Row gap="6px" align="center" alignItems="center" marginTop="10px">
                                    <TYPE.main fontSize={24} fontWeight={500}>
                                        +
                                        {formatStatsValue(
                                            BigInt(gecStatsV2.season3Stats.onChainPoint || '0').toString(),
                                        )}
                                    </TYPE.main>
                                    <TYPE.desc fontSize={14}>Points</TYPE.desc>
                                </Row>
                            </AutoColumn>
                            <AutoColumn style={{ height: '50px' }}>
                                <Row gap="2px" align="center" alignItems="center">
                                    <TYPE.main fontSize={10}>Invitation Points</TYPE.main>
                                </Row>
                                <Row gap="6px" align="center" alignItems="center" marginTop="10px">
                                    <TYPE.main fontSize={24} fontWeight={500}>
                                        +
                                        {formatStatsValue(
                                            BigInt(gecStatsV2.season3Stats.invitationPoint || '0').toString(),
                                        )}
                                    </TYPE.main>
                                    <TYPE.desc fontSize={14}>Points</TYPE.desc>
                                </Row>
                            </AutoColumn>
                        </RowBetween>
                    </CardContent>
                </Card>
                <Card
                    padding="20px"
                    height="169px"
                    width={isMobile ? '100%' : 'auto'}
                    background="#121212"
                    style={{ flexGrow: 1 }}
                >
                    <CardContent>
                        <AutoColumn gap="6px">
                            <Row align="center" alignItems="center">
                                <TYPE.main fontSize={14} fontWeight={500}>
                                    My Invitation
                                </TYPE.main>
                            </Row>
                            <TYPE.desc fontSize={10}>GOAT points become eligible for rewards</TYPE.desc>
                        </AutoColumn>
                        <Row gap="6px" align="baseline">
                            <div style={{ flex: 1 }}>
                                <Row gap="2px">
                                    <TYPE.desc fontSize={10}>Members</TYPE.desc>
                                </Row>
                                <TYPE.main fontSize={32} fontWeight={500}>
                                    {gecStatsV2.season3Stats.invitationCount}
                                </TYPE.main>
                            </div>
                        </Row>
                    </CardContent>
                </Card>
            </RowBetween>
        </>
    );
};

export default Season3;
